/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/services/app.shop.service.ts.
 */
import {Injectable} from '@angular/core';
import {
  ShopDialogsVertreterAddToWarenkorbComponent
} from '../modules/shop/dialogs/vertreter-add-to-warenkorb/shop.dialogs.vertreter-add-to-warenkorb.component';
import {Warenkorb} from '../models/warenkorb';
import {WarenkorbActionInfo} from '../models/warenkorb-action-info';
import {
  ShopWarenkorbActionInfoComponent
} from '../modules/shop/components/warenkorb-action-info/shop.warenkorb-action-info.component';
import {MatDialog} from '@angular/material/dialog';
import {AppWarenkorbService} from './app.warenkorb.service';
import {WarenkorbEntry} from '../models/warenkorb-entry';
import {AppPageloaderService} from './app.pageloader.service';
import {AppViewService} from './app.view.service';
import {AppDialogsService} from './app.dialogs.service';
import {MerklistEntry} from '../models/merklist-entry';
import {
  ShopDialogsNachliefernMultiFrageComponent
} from '../modules/shop/dialogs/nachliefern-multi-frage/shop.dialogs.nachliefern-multi-frage.component';
import {AppSnackbarService} from './app.snackbar.service';
import {Nachfolgeartikel} from '../models/nachfolgeartikel';
import {Artikel} from '../models/artikel';
import {
  ShopDialogsTryaddArtToWkConfirmComponent
} from '../modules/shop/dialogs/tryadd-art-to-wk-confirm/shop.dialogs.tryadd-art-to-wk-confirm.component';
import {AppEventService} from './app.event.service';
import {
  ShopDialogsVerfuegbarkeitsCheckConfirmComponent
} from '../modules/shop/dialogs/verfuegbarkeits-check-confirm/shop.dialogs.verfuegbarkeits-check-confirm.component';
import {
  ShopDialogsAlternativArtikelSucheComponent
} from '../modules/shop/dialogs/alternativ-artikel-suche/shop.dialogs.alternativ-artikel-suche.component';
import {AppConfigService} from './app.config.service';
import {GuiMessage} from '../models/gui-message';
import {
  AppImportHinweisService,
  ImportHinweisResult
} from './app.import-hinweis.service';

/**
 * Zweck: Beschreibt class AppShopService und ihren Daten- oder Funktionsvertrag.
 */
@Injectable({providedIn: 'root'})
export class AppShopService {

  wkkref: any;

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private mdsvc: MatDialog, private wksvc: AppWarenkorbService, private loader: AppPageloaderService,
              private snackBarSvc: AppSnackbarService, private vsvc: AppViewService, private dsvc: AppDialogsService,
              private esvc: AppEventService, private cfg: AppConfigService,
              private importHinweisSvc: AppImportHinweisService) {
  }

/**
 * Beschreibt Methode addToPrimaryWarenkorb und ihren Rückgabevertrag.
 */
  addToPrimaryWarenkorb(entry: WarenkorbEntry | MerklistEntry, exec_after_add: any = null, actionSource: string = null) {
    return this.addToWarenkorb(this.wksvc.primary_warenkorb.value, entry, exec_after_add, false, actionSource);
  }

/**
 * Beschreibt Methode _checkEntriesMessages und ihren Rückgabevertrag.
 */
  _checkEntriesMessages(warenkorb: Warenkorb, toAddEntries: WarenkorbEntry[] | MerklistEntry[], messages: { title: string, msg: string, entry: WarenkorbEntry | MerklistEntry }[], exec_after_add: any = null) {
    if (messages && messages.length > 0) {
      const dialog = this.mdsvc.open(ShopDialogsNachliefernMultiFrageComponent,
        {
          data: messages
        });

      dialog.afterClosed().subscribe(entries => {
        if (entries) {
          entries.forEach(e => {
            toAddEntries.push(e);
          });

          this._prepareEntriesForImportHinweis(warenkorb, toAddEntries, preparedEntries => {
            this.do_addToWarenkorbMulti(warenkorb, preparedEntries, exec_after_add);
          });
        } else {
          exec_after_add?.([]);
        }
      });
    } else {
      this._prepareEntriesForImportHinweis(warenkorb, toAddEntries, preparedEntries => {
        this.do_addToWarenkorbMulti(warenkorb, preparedEntries, exec_after_add);
      });
    }
  }

/**
 * Beschreibt Methode addToWarenkorbDialog und ihren Rückgabevertrag.
 */
  addToWarenkorbDialog(entry: WarenkorbEntry | MerklistEntry) {
    const ref = this.mdsvc.open(ShopDialogsVertreterAddToWarenkorbComponent, {
      data: entry
    });
    ref.afterClosed().subscribe(d => {
    });
  }

/**
 * Beschreibt Methode addMultiToPrimaryWarenkorb und ihren Rückgabevertrag.
 */
  addMultiToPrimaryWarenkorb(entries: WarenkorbEntry[] | MerklistEntry[], exec_after_add: any = null) {
    return this.addMultiToWarenkorb(this.wksvc.primary_warenkorb.value, entries, exec_after_add);
  }

/**
 * Beschreibt Methode addMultiToWarenkorb und ihren Rückgabevertrag.
 */
  addMultiToWarenkorb(warenkorb: Warenkorb, entries: WarenkorbEntry[] | MerklistEntry[], exec_after_add: any = null) {
    const l = this.loader.start();

    const checkEntries = [];
    const toAddEntries = [];

    entries.forEach(entry => {
      if (entry.artikel.isVFStatusPruefbar()) {
        checkEntries.push(entry);
      } else {
        toAddEntries.push(entry);
      }
    });

    const checkDataEntry = [];
    const checkData = [];
    checkEntries.forEach(e => {
      let menge = 0;
      // tslint:disable-next-line:radix
      menge += parseInt(String(e.menge));
      // tslint:disable-next-line:radix
      menge += parseInt(String(e.freimenge));
      checkData.push({
        view_slug: e.view_slug,
        artikelnummer: e.artikel.ArtikelNummer,
        artikelmenge: menge,
        artikelpzn: e.artikel.PZN,
        artikelstatuscode: e.artikel.VerfuegbarkeitsstatusCode,
      });
      checkDataEntry.push(e);
    });

    if (checkData.length > 0) {
      this.vsvc.multiVerfuegbarkeitBySlug(checkData).subscribe({
        next: (responses) => {
          const messages: { title: string, msg: string, entry: any }[] = [];

          responses.forEach((s, idx) => {
            const menge = checkData[idx].artikelmenge;
            const entry: any = checkEntries[idx];

            let nur_teilmenge = false;
            let moegliche_menge = 0;

            if (s.Verfuegbarkeitsinformation) {
              s.Verfuegbarkeitsinformation.forEach(i => {
                if (i.LieferungMoeglich) {
                  moegliche_menge += i.Menge;
                }
                if (i.InfoText == 'Teilmenge lagernd') {
                  nur_teilmenge = true;
                }
              });
            }

            let artlabel = entry.artikel.ArtikelBezeichnung;
            if (!artlabel) {
              artlabel = entry.artikel.ArtikelName;
            }

            if (moegliche_menge < menge || nur_teilmenge) {
              const title = '<b>' + artlabel + ' - ' + entry.menge + 'Stk </b>';
              let msg = '';

              if (nur_teilmenge) {
                msg += 'Es ist nur eine Teilmenge sofort lieferbar!';

              } else if (moegliche_menge > 0 && moegliche_menge >= menge) {
                msg = 'Es sind nur ' + moegliche_menge + ' lieferbar!';

              } else {
                msg = 'Kann besorgt werden!';
              }

              messages.push({
                title: title,
                msg: msg,
                entry: entry
              });

            } else {
              toAddEntries.push(entry);
            }
          });

          this._checkEntriesMessages(warenkorb, toAddEntries, messages, exec_after_add);

          l.stop();
        },
        error: (e) => {
          l.stop();
          exec_after_add?.([]);
        }
      });
    } else {
      this._prepareEntriesForImportHinweis(warenkorb, toAddEntries, preparedEntries => {
        if (preparedEntries.length === 0) {
          exec_after_add?.([]);
          return;
        }
        const addedEntries = [];
        let remaining = preparedEntries.length;
        preparedEntries.forEach(entry => {
          this._addToWarenkorbPhase3(warenkorb, entry, (message?: GuiMessage) => {
            if (message?.state === 'success') {
              addedEntries.push(entry);
            }
            if (--remaining === 0) {
              exec_after_add?.(addedEntries);
            }
          });
        });
      });
    }
  }

/**
 * Beschreibt Methode fastOrder und ihren Rückgabevertrag.
 */
  fastOrder(entry: WarenkorbEntry) {
    this.wksvc.createFastOrderWarenkorb().subscribe(warenkorb => {
      this.addToWarenkorb(warenkorb, entry, (message?: GuiMessage) => {
        if (message?.state !== 'success') {
          return;
        }
        this.wksvc.sendWarenkorb(warenkorb).subscribe(() => {
          const i = new WarenkorbActionInfo();
          i.action = 'fastOrdered';
          i.info = new GuiMessage();
          i.info.state = 'success';
          i.info.message = 'Bestellung erfolgreich abgeschickt!';

          this.snackBarSvc.open(ShopWarenkorbActionInfoComponent, i, 2500);
        });
      });
    });
  }

/**
 * Beschreibt Methode addToWarenkorb und ihren Rückgabevertrag.
 */
  addToWarenkorb(warenkorb: Warenkorb, entry: WarenkorbEntry | MerklistEntry, exec_after_add: any = null, force = false, actionSource: string = null) {
    const l = this.loader.start();

    let menge = 0;
    // tslint:disable-next-line:radix
    menge += parseInt(String(entry.menge));
    // tslint:disable-next-line:radix
    if (entry.freimenge) {
      menge += parseInt(String(entry.freimenge));
    }

    if (force) {
      l.stop();
      this._addToWarenkorbPhase2(warenkorb, entry, exec_after_add, actionSource);
    } else {
      this.wksvc.tryAddToWarenkorbById(
        warenkorb.id,
        entry.view_slug,
        entry
      ).subscribe(state => {
        l.stop();
        const currentWarenkorbMenge = state.inCurrentWkEntryAmount !== undefined
          ? Number(state.inCurrentWkEntryAmount) || 0
          : undefined;
        const currentWarenkorbConsent = state.inCurrentWkEntryHatImportHinweisZugestimmt !== undefined &&
        state.inCurrentWkEntryHatImportHinweisZugestimmt !== null
          ? state.inCurrentWkEntryHatImportHinweisZugestimmt === true
          : undefined;
        const currentWarenkorbEntryId = state.inCurrentWkEntryId !== undefined && state.inCurrentWkEntryId !== null
          ? state.inCurrentWkEntryId
          : undefined;
        if (state.inCurrentWkAmount == 0 && state.inOtherWkAmount == 0 && state.inOrdersAmount == 0 && state.inResidues == 0) {
          this._addToWarenkorbPhase2(warenkorb, entry, exec_after_add, actionSource,
            currentWarenkorbMenge, currentWarenkorbConsent, currentWarenkorbEntryId);

        } else {
          const ref = this.mdsvc.open(ShopDialogsTryaddArtToWkConfirmComponent,
            {
              data: {
                artikel: entry.artikel,
                state: state,
                amount: menge,
              },
            }
          );

          ref.afterClosed().subscribe(resp => {
            if (resp && resp.state == 'setAmount') {
              entry.gui_targetMenge = resp.setAmount;
              entry.menge = resp.amount;
              this._addToWarenkorbPhase2(warenkorb, entry, exec_after_add, actionSource,
                currentWarenkorbMenge, currentWarenkorbConsent, currentWarenkorbEntryId);

            } else if (resp && resp.state == 'raiseAmount') {
              entry.gui_targetMenge = resp.raiseAmount;
              this._addToWarenkorbPhase2(warenkorb, entry, exec_after_add, actionSource,
                currentWarenkorbMenge, currentWarenkorbConsent, currentWarenkorbEntryId);

            } else {
              if (exec_after_add) {
                exec_after_add();
              }
            }
          });
        }
      });
    }
  }

/**
 * Beschreibt Methode _showAlternativeArticles und ihren Rückgabevertrag.
 */
  _showAlternativeArticles(entry: WarenkorbEntry|MerklistEntry, wantedAmount = 0, exec_after_close_or_add: any = null) {
    this.vsvc.getBySlug(entry.view_slug).subscribe(view => {
      let ref = this.mdsvc.open(
        ShopDialogsAlternativArtikelSucheComponent,
        {
          data: {
            artikel: entry.artikel,
            view: view,
            wantedAmount: wantedAmount
          },
          width: '99vw',
          minWidth: '99vw'
        }
      );

      ref.afterClosed().subscribe(resp => {
        if (exec_after_close_or_add) {
          exec_after_close_or_add();
        }
      })
    });
  }

/**
 * Beschreibt Methode _addToWarenkorbPhase2 und ihren Rückgabevertrag.
 */
  _addToWarenkorbPhase2(warenkorb: Warenkorb, entry: WarenkorbEntry | MerklistEntry,
                        exec_after_close_or_add: any = null, actionSource: string = null,
                        currentWarenkorbMenge?: number, currentWarenkorbConsent?: boolean,
                        currentWarenkorbEntryId?: number) {
    const l = this.loader.start();

    let menge = 0;
    let vfCkMenge = 0;
    // tslint:disable-next-line:radix
    if (entry.gui_targetMenge) {
      vfCkMenge += parseInt(String(entry.gui_targetMenge));
    } else {
      vfCkMenge += parseInt(String(entry.menge));
    }

    menge += parseInt(String(entry.menge));
    // tslint:disable-next-line:radix
    if (entry.freimenge) {
      menge += parseInt(String(entry.freimenge));
      vfCkMenge += parseInt(String(entry.freimenge));
    }

    if (entry.artikel.isVFStatusPruefbar() || entry.artikel.isVFStatusPruefbarEpharmGh()) {
      this.vsvc.verfuegbarkeitBySlug(entry.view_slug, entry.artikel, vfCkMenge, warenkorb.supplierId).subscribe({
        next: (s) => {
          let nur_teilmenge = false;
          let moegliche_menge = 0;
          let not_allowed = false;
          let not_allowed_text = null;
          let kontingent_aufgebraucht = false;
          let nachfolgeArtikel: Nachfolgeartikel = null;
          let error_text = null;

          if (s.Nachfolgeartikel) {
            nachfolgeArtikel = s.Nachfolgeartikel;
          }

          if (s.Verfuegbarkeitsinformation) {
            s.Verfuegbarkeitsinformation.forEach(i => {
              if (i.LieferungMoeglich) {
                moegliche_menge += i.Menge;
              }
              if (i.InfoText == 'Teilmenge lagernd') {
                nur_teilmenge = true;
              }
              if (i.InfoCode == 'AP') {
                not_allowed = true;
                not_allowed_text = i.InfoText;

              } else if (i.InfoCode == 'KK') {
                kontingent_aufgebraucht = true;
              }

              if (i.InfoCode == 'ERROR') {
                error_text = i.InfoText;
              }
            });
          }

          let artlabel = entry.artikel.ArtikelBezeichnung;
          if (!artlabel) {
            artlabel = entry.artikel.ArtikelName;
          }

          if (nachfolgeArtikel) {
            const showNachfolgeDialog = (artikel: Artikel) => {
              const einkaufspreis = artikel.Kundeneinkaufspreis ?? nachfolgeArtikel.Kundeneinkaufspreis;
              const preisHtml = einkaufspreis != null && String(einkaufspreis).trim() !== ''
                ? '<br><br><div style="text-align: center">EP: ' + einkaufspreis + '&euro;</div>'
                : '';

              this.dsvc.confirm(
                'warning',
                'Nachfolgeartikel verfügbar!',
                'Wollen Sie den Nachfolgeartikel <strong>' + artikel.ArtikelName + '</strong> in den Warenkorb legen?' + preisHtml,
                () => {
                  const nachfolgeEntry = new WarenkorbEntry();
                  Object.assign(nachfolgeEntry, entry);
                  nachfolgeEntry.artikel = artikel;
                  nachfolgeEntry.artikel.Artikelstamm = entry.artikel.Artikelstamm;
                  nachfolgeEntry.hatImportHinweisZugestimmt = false;
                  nachfolgeEntry.importHinweisOption = null;
                  nachfolgeEntry.importHinweisEntscheidung = null;
                  this._addToWarenkorbPhase3(warenkorb, nachfolgeEntry, exec_after_close_or_add, actionSource);
                },
                () => {
                  exec_after_close_or_add();
                }
              );
            };

            this.vsvc.getOneById(entry.view_slug, String(nachfolgeArtikel.ArtikelNummer)).subscribe({
              next: artikel => showNachfolgeDialog(artikel),
              error: () => showNachfolgeDialog(nachfolgeArtikel)
            });

          } else if (error_text) {
            this.dsvc.info(
              'error',
              'Leider nicht möglich!',
              error_text
            );
            if (exec_after_close_or_add) {
              exec_after_close_or_add();
            }

          } else if (not_allowed) {
            this.dsvc.info(
              'error',
              'Sie haben leider Keine Berechtigung für diesen Artikel!',
              not_allowed_text
            );


            if (exec_after_close_or_add) {
              exec_after_close_or_add();
            }

          } else if (moegliche_menge < menge || nur_teilmenge) {
            let title = '';
            let msg = '';
            let showOnlyMoeglich = false;
            let showAlternativeArticleButton = false;
            let showSplitAlternativeArticleButton = false;

            if (kontingent_aufgebraucht) {
              title = 'Kontingent aufgebraucht!';
              msg = 'Leider ist Ihr Kontingent bereits aufgebraucht. Trotzdem in den Warenkorb legen?';
              showAlternativeArticleButton = true;

            } else if (nur_teilmenge) {
              title = 'Nicht vollständig lieferbar!';
              msg = 'Es ist nur eine Teilmenge sofort lieferbar! Trotzdem in den Warenkorb legen?';
              showAlternativeArticleButton = true;

            } else if (moegliche_menge > 0 && moegliche_menge <= menge) {
              title = 'Nicht vollständig lieferbar!';
              msg = 'Es sind nur ' + moegliche_menge + ' ' + entry.artikel.Packungseinheit + ' lieferbar! Trotzdem in den Warenkorb legen?';
              showAlternativeArticleButton = true;
              showSplitAlternativeArticleButton = true;
              showOnlyMoeglich = true;

            } else {
              title = 'Nicht auf Lager!';
              msg = 'Die gewünschte Menge von <hr><b>' +
                artlabel + ' - ' + entry.menge + 'Stk </b><hr> kann besorgt werden! Trotzdem in den Warenkorb legen?';
              showAlternativeArticleButton = true;
            }

            if (showAlternativeArticleButton || showSplitAlternativeArticleButton) {
              if (!this.cfg.featuresEnabled(['ArtikelKlassifizierungSuche'])) {
                showAlternativeArticleButton = false;
                showSplitAlternativeArticleButton = false;
              }
            }


            const dref = this.mdsvc.open(ShopDialogsVerfuegbarkeitsCheckConfirmComponent,
              {
                data: {
                  titel: title,
                  msg: msg,
                  showAlternativeArticleButton: showAlternativeArticleButton,
                  showSplitAlternativeArticleButton: showSplitAlternativeArticleButton,
                  showOnlyMoeglich: showOnlyMoeglich,
                }
              });

            dref.afterClosed().subscribe(ret => {
              if (ret == 'addAll') {
                this._addToWarenkorbPhase3(warenkorb, entry, exec_after_close_or_add, actionSource,
                  currentWarenkorbMenge, currentWarenkorbConsent, currentWarenkorbEntryId);

              } else if (ret == 'split') {
                const entry2 = JSON.parse(JSON.stringify(entry));
                entry2.menge = moegliche_menge;
                this._addToWarenkorbPhase3(warenkorb, entry2, exec_after_close_or_add, actionSource,
                  currentWarenkorbMenge, currentWarenkorbConsent, currentWarenkorbEntryId);

              } else if (ret == 'splitAndAlternative') {
                const entry2: any = JSON.parse(JSON.stringify(entry));
                const leftMenge = entry2.menge - moegliche_menge;
                entry2.menge = moegliche_menge;
                this._addToWarenkorbPhase3(warenkorb, entry2, null, actionSource,
                  currentWarenkorbMenge, currentWarenkorbConsent, currentWarenkorbEntryId);
                this._showAlternativeArticles(entry, leftMenge, exec_after_close_or_add);

              } else if (ret == 'alternative') {
                this._showAlternativeArticles(entry, entry.menge, exec_after_close_or_add);

              } else {
                if (exec_after_close_or_add) {
                  exec_after_close_or_add();
                }
              }
            });



          } else {
            this._addToWarenkorbPhase3(warenkorb, entry, exec_after_close_or_add, actionSource,
              currentWarenkorbMenge, currentWarenkorbConsent, currentWarenkorbEntryId);
          }
          l.stop();
        },
        error: (e) => {
          this.dsvc.confirm(
            'warning',
            'Verfügbarkeitsabfrage derzeit nicht möglich',
            'Trotzdem in den Warenkorb legen?',
            () => {
              this._addToWarenkorbPhase3(warenkorb, entry, exec_after_close_or_add, actionSource,
                currentWarenkorbMenge, currentWarenkorbConsent, currentWarenkorbEntryId);
            },
            () => {
              if (exec_after_close_or_add) {
                exec_after_close_or_add();
              }
            }
          );
          l.stop();
        }
      });
    } else {
      l.stop();
      this._addToWarenkorbPhase3(warenkorb, entry, exec_after_close_or_add, actionSource,
        currentWarenkorbMenge, currentWarenkorbConsent, currentWarenkorbEntryId);
    }
  }

  private do_addToWarenkorbMulti(warenkorb: Warenkorb, entries: WarenkorbEntry[] | MerklistEntry[], exec_after_add: any = null, actionSource: string = null) {
    const l = this.loader.start();

    if (warenkorb && entries.length > 0) {
      this.wksvc.addMultiToWarenkorbById(
        warenkorb.id,
        entries,
        actionSource
      ).subscribe({
        next: (msgs) => {
          l.stop();
          this.esvc.addGuiEvent('warenkorb_article_added');

          entries.forEach(e => {
            this.esvc.addGuiEvent('shop_reset_entry_fields', {
              ArtikelNummer: e.artikel.ArtikelNummer
            });
          });

          msgs.forEach(m => {
            const i = new WarenkorbActionInfo();
            i.action = 'add';
            i.info = m;

            this.snackBarSvc.open(
              ShopWarenkorbActionInfoComponent,
              i,
              2500,
              );
          });

          if (exec_after_add) {
            exec_after_add(entries);
          }

        }, error: () => {
          l.stop();
          exec_after_add?.([]);
        }
      });
    } else if (entries.length == 0) {
      this.snackBarSvc.openMessage('Nichts hinzuzufügen!');
      l.stop();
      exec_after_add?.([]);

    } else {
      this.snackBarSvc.openMessage('Fehlgeschlagen. Kein Warenkorb ausgewählt!');
      l.stop();
      exec_after_add?.([]);
    }
  }

  private _findCurrentWarenkorbEntry(warenkorb: Warenkorb, entry: WarenkorbEntry | MerklistEntry,
                                     currentWarenkorbEntryId?: number): WarenkorbEntry | undefined {
    if (!warenkorb || !warenkorb.entries || !entry || !entry.artikel) {
      return undefined;
    }

    if (currentWarenkorbEntryId !== undefined) {
      const targetEntry = warenkorb.entries.find(currentEntry =>
        String(currentEntry.id) === String(currentWarenkorbEntryId)
      );
      if (targetEntry) {
        return targetEntry;
      }
    }

    return warenkorb.entries.find(currentEntry =>
      currentEntry.artikel &&
      String(currentEntry.artikel.ArtikelNummer) === String(entry.artikel.ArtikelNummer) &&
      String(currentEntry.artikel.Artikelstamm || '').toUpperCase() ===
      String(entry.artikel.Artikelstamm || '').toUpperCase()
    );
  }

  private _prepareEntriesForImportHinweis(warenkorb: Warenkorb, entries: WarenkorbEntry[] | MerklistEntry[],
                                           onReady: (entries: (WarenkorbEntry | MerklistEntry)[]) => void,
                                           index = 0, preparedEntries: (WarenkorbEntry | MerklistEntry)[] = []) {
    if (index >= entries.length) {
      onReady(preparedEntries);
      return;
    }

    const entry = entries[index];
    this._prepareEntryForImportHinweis(warenkorb, entry, () => {
      if ((Number(entry.menge) || 0) > 0) {
        preparedEntries.push(entry);
      }
      this._prepareEntriesForImportHinweis(warenkorb, entries, onReady, index + 1, preparedEntries);
    });
  }

  private _prepareEntryForImportHinweis(warenkorb: Warenkorb, entry: WarenkorbEntry | MerklistEntry,
                                         onReady: () => void, currentWarenkorbMenge?: number,
                                         currentWarenkorbConsent?: boolean, currentWarenkorbEntryId?: number) {
    const currentEntry = this._findCurrentWarenkorbEntry(warenkorb, entry, currentWarenkorbEntryId);
    const currentAmount = currentWarenkorbMenge !== undefined
      ? Number(currentWarenkorbMenge) || 0
      : currentEntry ? Number(currentEntry.menge) || 0 : 0;
    const requestedAmount = Number(entry.menge) || 0;
    const consent = currentWarenkorbConsent !== undefined
      ? currentWarenkorbConsent
      : currentEntry?.hatImportHinweisZugestimmt === true || entry.hatImportHinweisZugestimmt === true;
    const resultingAmount = currentAmount + requestedAmount;

    if (!AppImportHinweisService.needsDecision(entry.artikel, resultingAmount, consent)) {
      if (currentEntry?.hatImportHinweisZugestimmt === true) {
        entry.hatImportHinweisZugestimmt = true;
        entry.importHinweisOption = currentEntry.importHinweisOption;
      }
      onReady();
      return;
    }

    this.importHinweisSvc.open(entry.artikel).subscribe((result: ImportHinweisResult) => {
      if (result.decision === 'confirm') {
        entry.hatImportHinweisZugestimmt = true;
        entry.importHinweisOption = result.option;
        entry.importHinweisEntscheidung = 'confirm';
        onReady();
        return;
      }

      entry.hatImportHinweisZugestimmt = false;
      entry.importHinweisOption = null;
      entry.importHinweisEntscheidung = 'reduce';
      entry.gui_importHinweisAbgelehnt = true;

      const targetAmount = AppImportHinweisService.targetAmountAfterReduction();
      if (currentEntry && currentAmount >= targetAmount) {
        const reducedEntry = JSON.parse(JSON.stringify(currentEntry));
        reducedEntry.menge = targetAmount;
        reducedEntry.hatImportHinweisZugestimmt = false;
        reducedEntry.importHinweisOption = null;
        reducedEntry.importHinweisEntscheidung = 'reduce';
        reducedEntry.gui_importHinweisAbgelehnt = true;
        this.wksvc.updateForWarenkorbById(warenkorb.id, reducedEntry).subscribe(() => {
          entry.menge = 0;
          onReady();
        });
        return;
      }

      entry.menge = Math.max(0, targetAmount - currentAmount);
      if (entry.menge === 0 && currentEntry) {
        currentEntry.gui_importHinweisAbgelehnt = true;
        this.snackBarSvc.openMessage('Die Menge bleibt auf 3 Stück begrenzt.', 4000);
      }
      onReady();
    });
  }

  private _addToWarenkorbPhase3(warenkorb: Warenkorb, entry: WarenkorbEntry | MerklistEntry,
                                exec_after_add: any = null, actionSource: string = null,
                                currentWarenkorbMenge?: number, currentWarenkorbConsent?: boolean,
                                currentWarenkorbEntryId?: number) {
    this._prepareEntryForImportHinweis(warenkorb, entry, () => {
      if ((Number(entry.menge) || 0) <= 0) {
        if (exec_after_add) {
          exec_after_add();
        }
        return;
      }

      const l = this.loader.start();

      if (warenkorb) {
        this.wksvc.addToWarenkorbById(
          warenkorb.id,
          entry.view_slug,
          entry,
          actionSource
        ).subscribe({
          next: (m) => {
            l.stop();

            this.esvc.addGuiEvent('shop_reset_entry_fields', {
              ArtikelNummer: entry.artikel.ArtikelNummer
            });

            if (warenkorb.id != '__FAST_ORDER__') {
              this.esvc.addGuiEvent('warenkorb_article_added');
              const i = new WarenkorbActionInfo();
              i.action = 'add';
              i.info = m;

              if (exec_after_add) {
                exec_after_add(m);
              }

              this.snackBarSvc.open(ShopWarenkorbActionInfoComponent, i, 2500);
            } else {
              if (exec_after_add) {
                exec_after_add(m);
              }
            }
          }, error: () => {
            if (exec_after_add) {
              exec_after_add();
            }
            l.stop();
          }
        });
      } else {
        this.snackBarSvc.openMessage('Fehlgeschlagen. Kein Warenkorb ausgewählt!');
      }
    }, currentWarenkorbMenge, currentWarenkorbConsent, currentWarenkorbEntryId);
  }
}
